import { findAgeOverlaps } from "@gazelab/shared";

export interface GroupDraft {
  key: string;
  id?: string;
  code: string;
  name: string;
  minAge: number;
  maxAge: number;
  sortOrder: number;
}

/** Valida un conjunto de grupos en el editor: rango, códigos únicos y solapamientos. */
export function validateGroups(groups: ReadonlyArray<GroupDraft>): string[] {
  const errors: string[] = [];
  const codes = new Set<string>();
  for (const g of groups) {
    if (!/^[a-z0-9_-]+$/.test(g.code)) errors.push(`Código «${g.code || "(vacío)"}»: usa minúsculas, números, guion o guion bajo.`);
    if (codes.has(g.code)) errors.push(`Código duplicado: «${g.code}».`);
    codes.add(g.code);
    if (!g.name.trim()) errors.push(`El grupo «${g.code}» necesita nombre.`);
    if (!Number.isInteger(g.minAge) || !Number.isInteger(g.maxAge)) errors.push(`«${g.code}»: las edades deben ser enteras.`);
    else if (g.maxAge < g.minAge) errors.push(`«${g.code}»: la edad máxima debe ser ≥ la mínima.`);
    else if (g.minAge < 0 || g.maxAge > 130) errors.push(`«${g.code}»: edades fuera de rango (0–130).`);
  }
  for (const [a, b] of findAgeOverlaps(groups)) errors.push(`Los rangos de «${a}» y «${b}» se solapan.`);
  if (groups.length < 2) errors.push("Se necesitan al menos dos grupos para comparar.");
  return errors;
}
